import React from "react";
import { useFormContext } from "react-hook-form";
import { i18n } from "@/i18n";
import { InputWrapper } from "@/components/FormInputs/InputWrapper";
import { FormValues } from "../types";
import { Input } from "@/components/ui";

export function NameInput({ disabled }: { disabled?: boolean }) {
  const {
    register,
    formState: { errors },
  } = useFormContext<FormValues>();

  return (
    <InputWrapper
      name="name"
      label={i18n.t("bulkMessaging.basicInformation.inputs.campaign.label")}
      error={errors.name}
    >
      <Input
        type="text"
        id="name"
        disabled={disabled}
        {...register("name", {
          required: {
            value: true,
            message: i18n.t(
              "bulkMessaging.basicInformation.inputs.campaign.error",
            ),
          },
        })}
        placeholder={i18n.t(
          "bulkMessaging.basicInformation.inputs.campaign.placeholder",
        )}
      />
    </InputWrapper>
  );
}
